var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "26px",
    viewBox: "0 0 37 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visaCard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Native-IOS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Credit-Card-Payment",
    transform: "translate(-305.000000, -225.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visaCard",
    transform: "translate(281.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7,24.4173913 C36.7,25.2652174 36.1,25.9434783 35.35,25.9434783 L1.75,25.9434783 C1,25.9434783 0.4,25.2652174 0.4,24.4173913 L0.4,1.5826087 C0.4,0.734782609 1,0.0565217391 1.75,0.0565217391 L35.35,0.0565217391 C36.1,0.0565217391 36.7,0.734782609 36.7,1.5826087 L36.7,24.4173913 L36.7,24.4173913 Z",
    id: "Path",
    fill: "#1A1F71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,7.57391304 L10.15,18.4826087 L7.5,18.4826087 L5.5,9.77826087 C5.4,9.26956522 5.25,9.04347826 4.9,8.8173913 C4.3,8.47826087 3.3,8.0826087 2.45,7.91304348 L2.5,7.57391304 L6.75,7.57391304 C7.3,7.57391304 7.8,7.96956522 7.9,8.70434783 L8.95,15.0347826 L11.55,7.63043478 L14.2,7.63043478 L14.2,7.57391304 Z M24.55,14.9217391 C24.55,12.0391304 21.05,11.8695652 21.05,10.626087 C21.05,10.2304348 21.4,9.83478261 22.1,9.72173913 C22.45,9.66521739 23.45,9.60869565 24.55,10.2304348 L25,7.91304348 C24.4,7.68695652 23.65,7.40434783 22.65,7.40434783 C20.2,7.40434783 18.45,8.87391304 18.45,11.0217391 C18.45,12.6043478 19.7,13.4521739 20.65,13.9608696 C21.6,14.4695652 21.95,14.8086957 21.95,15.3173913 C21.95,16.0521739 21.2,16.3913043 20.45,16.3913043 C19.2,16.3913043 18.45,15.9956522 17.9,15.7130435 L17.45,18.0869565 C18.05,18.3695652 19.1,18.6521739 20.2,18.6521739 C22.8,18.6521739 24.5,17.1826087 24.55,14.9217391 M31.05,18.4826087 L33.35,18.4826087 L31.35,7.57391304 L29.2,7.57391304 C28.7,7.57391304 28.3,7.91304348 28.15,8.36521739 L24.4,18.4826087 L27,18.4826087 L27.5,16.8434783 L30.7,16.8434783 L31.05,18.4826087 Z M28.25,14.6391304 L29.55,10.5695652 L30.3,14.6391304 L28.25,14.6391304 Z M17.75,7.57391304 L15.7,18.4826087 L13.2,18.4826087 L15.25,7.57391304 L17.75,7.57391304 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/visaCard.275bcb60e3ed4326eb31c5cab146ce0a.svg";
export { ForwardRef as ReactComponent };